import { ASSIST } from '../constants';
import { useChannelAccess } from 'src/hooks/useChannelAccess';
import { isChannelTabRestricted } from 'src/utils/channelAccess';

/** For granted users: whether an Insights channel (`product_mode`) is off limits. Overview and Topics count as widget. */
export const useInsightsChannelAccess = () => {
  const { hasGrants, isLoading, visibleChannels } = useChannelAccess();
  const isRestricted = (productMode: string | null | undefined) =>
    productMode !== ASSIST &&
    isChannelTabRestricted(productMode, hasGrants, visibleChannels);
  return { isLoading, isRestricted };
};
